import * as actions from './actions'
import * as getters from './getters'

import list from '@/store/shared/selectableList'
import agreements from '@/store/financeables/agreements'
import expedients from '@/store/financeables/expedients'

export default {
  namespaced: true,
  actions,
  getters,
  modules: {
    list,
    agreements,
    expedients
  }
}
